/**
 * Ad utility functions — checks user tier and tester status to hide ads.
 */

export function shouldShowAds(user) {
  if (!user) return true;
  // Testers never see ads
  if (user.is_tester) return false;
  const tier = user.tier || "free";
  if (tier === "free") return true;
  const expires = user.tier_expires_at;
  if (expires && new Date(expires) < new Date()) return true;
  return false;
}
